import React, { useEffect } from "react";
import styles from "./WhyIFillip.module.css";

// Placeholder images - replace with actual images
import heroBg from "../../assets/images/heroBg.png";
import omniChannelIcon from "../../assets/images/omni.png";
import cloudHostedIcon from "../../assets/images/cloud.png";
import supportIcon from "../../assets/images/support.png";
import saasModelIcon from "../../assets/images/saas.png";
import iotEnabledIcon from "../../assets/images/iot.png";
import apiDrivenIcon from "../../assets/images/api.png";
import schoolIcon from "../../assets/images/schoolimg.png";
import teacherIcon from "../../assets/images/teacher.png";
import studentsIcon from "../../assets/images/student.png";
import parentsIcon from "../../assets/images/parent.png";
import { Helmet } from "react-helmet-async";

const WhyIFillip = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  }, []); // Empty dependency array ensures this runs only once when component mounts
  return (
    <>
      <Helmet>
        <title>
         Know Why ifillip Is trusted Smart School Management System
        </title>
        <meta
          name="description"
          content="Discover why schools choose ifillip a Smart School Management System built to simplify all administration activities, connecting teachers, students, and parents anytime, any where with ease"
        />
      </Helmet>
      <div className={styles.whyIFillipPage}>
        {/* ===== SECTION 1: Hero Section ===== */}
        <section className={styles.heroSection}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <h1 className={styles.heroTitle}>
                  <span className={styles.heroTitleLarge}>S</span>
                  <span style={{ fontSize: "45px" }}>ecurity</span> |{" "}
                  <span className={styles.heroTitleLarge}>F</span>
                  <span style={{ fontSize: "45px" }}>lexibility</span> |{" "}
                  <span className={styles.heroTitleLarge}>S</span>
                  <span style={{ fontSize: "45px" }}>calability</span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECTION 2: Technical Features (Row 1) ===== */}
        <section className={styles.technicalFeaturesSection}>
          <div className="container">
            <h2 className={styles.sectionHeading}>TECHNICAL FEATURES</h2>
            <div className={styles.headingDivider}></div>

            <div className={`row ${styles.featuresRow}`}>
              {/* Omni-Channel */}
              <div className="col-lg-4 col-md-4">
                <div className={styles.featureCard}>
                  <div className={styles.featureIconWrapper}>
                    <img
                      src={omniChannelIcon}
                      alt="Omni-Channel"
                      className={styles.featureIcon}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Omni-Channel</h3>
                  <p className={styles.featureDescription}>
                    Provide a dynamic experience to all stakeholders by
                    communicating with a single database from both desktops &
                    mobile platforms
                  </p>
                </div>
              </div>

              {/* Cloud-hosted */}
              <div className="col-lg-4 col-md-4">
                <div className={styles.featureCard}>
                  <div className={styles.featureIconWrapper}>
                    <img
                      src={cloudHostedIcon}
                      alt="Cloud-hosted"
                      className={styles.featureIcon}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Cloud-hosted</h3>
                  <p className={styles.featureDescription}>
                    Be assured of your data protection, as your institution data
                    resides safely & securely in an azure cloud with restrictive
                    access to individual users based on roles
                  </p>
                </div>
              </div>

              {/* 24X7 Support */}
              <div className="col-lg-4 col-md-4">
                <div className={styles.featureCard}>
                  <div className={styles.featureIconWrapper}>
                    <img
                      src={supportIcon}
                      alt="24X7 Support"
                      className={styles.featureIcon}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>
                    <em>24X7 Support</em>
                  </h3>
                  <p className={styles.featureDescription}>
                    Get more value for your investment with round-the-clock
                    support from our dedicated support team. Reach us through
                    our toll-free number or email for a swift response
                  </p>
                </div>
              </div>
            </div>

            {/* ===== Technical Features (Row 2) ===== */}
            <div className={`row ${styles.featuresRow}`}>
              {/* SaaS Model */}
              <div className="col-lg-4 col-md-4">
                <div className={styles.featureCard}>
                  <div className={styles.featureIconWrapper}>
                    <img
                      src={saasModelIcon}
                      alt="SaaS Model"
                      className={styles.featureIcon}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>SaaS Model</h3>
                  <p className={styles.featureDescription}>
                    Focus solely on your school growth & development leaving the
                    management of your school ERP, data and related maintenance
                    to our experts
                  </p>
                </div>
              </div>

              {/* IOT – enabled */}
              <div className="col-lg-4 col-md-4">
                <div className={styles.featureCard}>
                  <div className={styles.featureIconWrapper}>
                    <img
                      src={iotEnabledIcon}
                      alt="IOT enabled"
                      className={styles.featureIcon}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>IOT – enabled</h3>
                  <p className={styles.featureDescription}>
                    Use IOT-automation to capture attendance and also increase
                    security within your school premises by tracking student's
                    movements unobtrusively
                  </p>
                </div>
              </div>

              {/* API-Driven */}
              <div className="col-lg-4 col-md-4">
                <div className={styles.featureCard}>
                  <div className={styles.featureIconWrapper}>
                    <img
                      src={apiDrivenIcon}
                      alt="API-Driven"
                      className={styles.featureIcon}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>API-Driven</h3>
                  <p className={styles.featureDescription}>
                    Provides for harmonious interaction with external
                    applications & services giving optimal user experience
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECTION 3: Easy to Configure ===== */}
        <section className={styles.configureSection}>
          <div className={styles.configureOverlay}>
            <div className="container">
              <div className={styles.configureContent}>
                <h2 className={styles.configureTitle}>
                  It's is easy to configure !!
                </h2>
                <p className={styles.configureText}>
                  iFillip can be accessed through a variety of configurable user
                  interfaces to provide simple access and relevant information
                  to every individual across the educational institution
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECTION 4: For Stakeholders ===== */}
        <section className={styles.stakeholdersSection}>
          <div className="container">
            <h2 className={styles.stakeholdersHeading}>FOR STAKEHOLDERS...</h2>
            <div className={styles.headingDivider}></div>
            <p className={styles.stakeholdersSubtext}>
              iFillip allows various stakeholders to update data & share
              communications from a single web-based system hosted securely in
              the cloud
            </p>

            {/* School Management */}
            <div className={styles.stakeholderBlock}>
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3">
                  <div className={styles.stakeholderImageWrapper}>
                    <img
                      src={schoolIcon}
                      alt="School Management"
                      className={styles.stakeholderImage}
                    />
                  </div>
                </div>
                <div className="col-lg-9 col-md-9">
                  <h3 className={styles.stakeholderTitle}>School Management</h3>
                  <p className={styles.stakeholderTagline}>
                    Streamlined Processes.
                  </p>
                  <p className={styles.stakeholderDescription}>
                    iFillip helps automate & streamline internal processes &
                    controls thereby freeing your key resources like teachers &
                    admin staff from mundane activities and help in increasing
                    productivity & efficiency. With cutting edge technology and
                    features like multi-school tenant model coupled with
                    readymade access to secure data, Ifllip is the go-to school
                    & learning management system.
                  </p>
                </div>
              </div>
            </div>

            <hr className={styles.stakeholderDivider} />

            {/* Teachers */}
            <div className={styles.stakeholderBlock}>
              <div className="row align-items-center">
                <div className="col-lg-9 col-md-9">
                  <h3 className={styles.stakeholderTitle}>Teachers</h3>
                  <p className={styles.stakeholderTagline}>
                    Increased Collaboration & Better Organization.
                  </p>
                  <p className={styles.stakeholderDescription}>
                    Pedagogy is undergoing a paradigm shift from a
                    "teacher-centered" to "student-centered" learning, Teachers
                    has to constantly engage the student and provide instant
                    feedback. This calls for substantial time & effort on the
                    part of the teaching fraternity, By reducing paperwork and
                    providing flexibility of 24X7 access to resources, iFillip
                    strives to 'Put Education First'
                  </p>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div
                    className={`${styles.stakeholderImageWrapper} ${styles.stakeholderImageRight}`}
                  >
                    <img
                      src={teacherIcon}
                      alt="Teachers"
                      className={styles.stakeholderImage}
                    />
                  </div>
                </div>
              </div>
            </div>

            <hr className={styles.stakeholderDivider} />

            {/* Students */}
            <div className={styles.stakeholderBlock}>
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3">
                  <div className={styles.stakeholderImageWrapper}>
                    <img
                      src={studentsIcon}
                      alt="Students"
                      className={styles.stakeholderImage}
                    />
                  </div>
                </div>
                <div className="col-lg-9 col-md-9">
                  <h3 className={styles.stakeholderTitle}>Students</h3>
                  <p className={styles.stakeholderTagline}>
                    Students love technologies & gadgets...
                  </p>
                  <p className={styles.stakeholderDescription}>
                    Using iFillip, students get round the clock access to
                    various resources, teachers & peer groups, Students become
                    active participants in a moderated classroom community that
                    encourages collaboration, discussion & creativity – which is
                    just how they like it! Apart from knowledge sharing, iFillip
                    also supports fun activities like student poll,
                    Announcements, Hall of Fame, Birthday wishes, etc. thereby
                    fostering all round student development.
                  </p>
                </div>
              </div>
            </div>

            <hr className={styles.stakeholderDivider} />

            {/* Parents */}
            <div className={styles.stakeholderBlock}>
              <div className="row align-items-center">
                <div className="col-lg-9 col-md-9">
                  <h3 className={styles.stakeholderTitle}>Parents</h3>
                  <p className={styles.stakeholderTagline}>
                    Timely Updates. Active Participation.
                  </p>
                  <p className={styles.stakeholderDescription}>
                    Get more involved in your child's education with constant
                    updates & feedback on their performance & progress. iFillip
                    messaging module helps to interact with teachers on the go
                    instead of waiting for school open days. Parents also have
                    access to data in real time and can see multiple student in
                    a school using a single login.
                  </p>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div
                    className={`${styles.stakeholderImageWrapper} ${styles.stakeholderImageRight}`}
                  >
                    <img
                      src={parentsIcon}
                      alt="Parents"
                      className={styles.stakeholderImage}
                    />
                  </div>
                </div>
              </div>
            </div>

            <hr className={styles.stakeholderDivider} />
          </div>
        </section>
      </div>
    </>
  );
};

export default WhyIFillip;
